// extracted by mini-css-extract-plugin
export default {"root":"styles_root__8X9Z9","container":"styles_container__5E10D","logo":"styles_logo__x8FEi","copyright":"styles_copyright__YqNVI"};